import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list", "buttonText"]

    copy() {
        if (!navigator.clipboard) {
            // Clipboard API not available (likely insecure context - can occur in local development)
            console.error("Clipboard API not available.");
            return;
        }

        const listElement = this.listTarget;
        const text = listElement.innerText;
        const duplicatesIndex = text.indexOf('Automatically removed duplicates:');
        const finalText = duplicatesIndex > -1 ? text.substring(0, duplicatesIndex).trim() : text.trim();

        navigator.clipboard.writeText(finalText).then(() => {
            const originalText = this.buttonTextTarget.innerText;
            this.buttonTextTarget.innerText = "Copied!";
            setTimeout(() => {
                this.buttonTextTarget.innerText = originalText;
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    }
} 